import React from "react";
import classnames from "classnames";
import { Element } from "../base";
import MenuListItem from "./item";

interface IProps {
    className?: string;
    title?: string;
    children: React.ReactNode;
}

function MenuList(props: IProps) {
    const { className, title, children, ...rest } = props;
    return (
        <>
            {title && <p className="menu-label">{title}</p>}
            <Element
                renderAs="ul"
                className={classnames("menu-list", "block", className)}
                {...rest}
            >
                {children}
            </Element>
        </>
    );
}

MenuList.Item = MenuListItem;

export default MenuList;
